<template>
  <section>
    <div class="form" ref="form">
      <div class="row no-padd">
        <div class="col-md-6 form-group">
          <input-control 
            v-model="voucher.codigoVoucher" 
            name="codigoVoucher" 
            label="Código Voucher"
            cssClass="text-upper"
            :valid="valid.codigoVoucher"
            @keyup="valid.codigoVoucher = true"
            required
          />
        </div>
      </div>
      <div class="row no-padd">
        <div class="col-md-6 form-group">
          <input-control 
            v-model="voucher.inicio" 
            name="inicio" 
            label="Início" 
            type="date"
            :valid="valid.inicio"
            @keyup="valid.inicio = true"
            required 
          />
        </div>
        <div class="col-md-6 form-group">
          <input-control 
            v-model="voucher.fim"
            name="fim" 
            label="Final" 
            type="date" 
            :valid="valid.fim"
            @keyup="valid.fim = true"
            required 
          />
        </div>
      </div>
      <div class="row no-padd">
        <div class="col-md-6 form-group">
          <input-control 
            v-model="voucher.valor" 
            name="valor" 
            label="Valor" 
            @input="maskMoney($event,2,'valor')"
            type="number" 
            :disabled="!!voucher.porcentagem"
            :required="!voucher.porcentagem"
            :valid="valid.valor"
            @keyup="valid.valor = true" 
          />
        </div>
        <div class="col-md-6 form-group">
          <input-control 
            v-model="voucher.porcentagem" 
            name="porcentagem" 
            label="Porcentagem" 
            @input="maskMoney($event,3,'porcentagem')" 
            type="number" 
            :disabled="!!voucher.valor"
            :required="!voucher.valor" 
            :valid="valid.porcentagem"
            @keyup="valid.porcentagem = true" 
          />
        </div>
      </div>
    </div>
    <footer>
      <a href="#" class="btn btn-secondary" @click.prevent="$emit('onClose')">
        Cancelar
      </a>
      <a href="#" class="btn btn-primary" @click.prevent="save()">
        Salvar
      </a>
    </footer>
  </section>
</template>

<script>
import MarketplaceService from '@/services/marketplace.service.js'
import FinanceiroService from '@/services/financeiro.service.js'
import moment from 'moment'
import FormService from '@/services/form.service.js'

// import { createSelectOptions } from '@/services/utils.service'

export default {
  props: {
    scope: Object
  },
  components: {

  },
  data () {
    return {
      voucher: {
        idVoucher: null,
        codigoVoucher: null,
        inicio: null,
        fim: null,
        idTipoVoucher: null,
        idTurma: null,
        idAluno: null,
        idPessoa: null,
        idCategoriaLoja: null,
        idTipoMaterial: null,
        idSolicitacaoCancelamento: null,
        porcentagem: null,
        valor: null,
        status: 0,
        nomeAluno: null,
        nomeResponsavel: null,
        nomeUso: null
      },
      valid: {
        codigoVoucher: true,
        inicio: true,
        fim: true,
        valor: true,
        porcentagem: true
      },
      options: {
        indexador: [
          { value: 'idPessoa', label: 'Pessoa' },
          { value: 'idAluno', label: 'Aluno' },
          { value: 'idcheckoutMarketplace', label: 'Checkout' },
          { value: 'idSolicitacaoCancelamento', label: 'Solicitação Cancelamento' },
          { value: 'idcheckoutMarketplace_idSolicitacaoCancelamento', label: 'Checkout + Solicitação Cancelamento' }
        ],
        tiposVoucher: [
          { value: "nceComplementar", label: "NCE Complementar" },
          { value: "cdfComplementar", label: "CDF Complementar" },
          { value: "cancelamento", label: "Cancelamento" },
          { value: "red", label: "Red Week" }
        ],
      }
    }
  },
  mounted () {
    if ( this.scope ) {
      this.voucher = Object.assign({}, this.scope)
      this.voucher.inicio = this.voucher.inicio.split(" ")[0]
      this.voucher.fim = this.voucher.fim.split(" ")[0]
      console.log("scope:", this.scope)
      this.getTipoVoucher()
    }
  },
  methods: {
    getTipoVoucher() {
      if (this.voucher.idTipoVoucher) {
        MarketplaceService.getTipoVoucher(this.voucher.idTipoVoucher).then(
          (response) => {
            if (response.data.length > 0) {
              // this.options.tipo = createSelectOptions(response.data, 'idTipoVoucher', 'tipo')
            } else {
              window.toaster.emit('open', { style: 'error', message: 'Erro ao carregar os dados', floater: true })
            }
          },
          (error) => {
            console.error('Erro ao buscar TipoVoucher:', error);
            window.toaster.emit('open', { style: 'error', message: 'Erro ao carregar os dados', floater: true })
          }
        )
      }
    },
    changeFinalDate () {
      const endDate = moment(this.voucher.inicio,'YYYY-MM-DD').add(this.scope.duracaoDias,'days')
      this.voucher.fim = endDate.format('YYYY-MM-DD')
    },
    maskMoney(e, step, field) {
				let value = e.target.value ?? ''

				// Se apagou tudo: limpa o model e libera o outro campo
				if (value === '') {
					this.voucher[field] = null
					return
				}

				// normaliza
				value = String(value).replace(',', '.')

				const regex = new RegExp(`^\\d+(\\.\\d{0,${step}})?$`)
				if (!regex.test(value)) {
					value = value.slice(0, -1)
					e.target.value = value

					// se ficou vazio depois do slice, limpa o model
					if (value === '') this.voucher[field] = null
				}

				// garante que o model acompanha o input (number)
				this.voucher[field] = value === '' ? null : Number(value)
		},
    resetValidation () {
      this.valid =  {
        codigoVoucher: true,
        inicio: true,
        fim: true,
        valor: true,
        porcentagem: true
      }
    },
    save () {
      this.resetValidation()

      const valid = FormService.validate(this.$refs.form, this.valid)

      console.log(valid)

      if ( valid.response ) {
        const payload = Object.assign({},this.voucher)
        const time = '00:00:00'

        payload.codigoVoucher = payload.codigoVoucher ? payload.codigoVoucher.toUpperCase() : null
        payload.inicio = `${moment().format('YYYY-MM-DD')} ${time}`
        payload.fim = `${payload.fim} ${time}`
        payload.porcentagem = eval(payload.porcentagem)
        payload.valor = eval(payload.valor)

        window.spinner.emit('open')

        FinanceiroService.createEditVoucher( payload, this.voucher.idVoucher ).then(
          response => {
            if ( response.status == 200 || response.status == 201 ) {
              window.toaster.emit('open', { style: 'success', message: 'Tudo certo. Voucher editado com sucesso.', floater: true })

              setTimeout(() => {
                this.$emit('onClose', true)
              },2000)
              
            }
          }
        ).catch( error => { window.toaster.emit('open', { style: 'error', message: 'Ops! Algo aconteceu. Não foi possível salvar o voucher. ' + error, floater: true }) })
        .finally(() => { window.spinner.emit('close') })
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .form {
    padding: $hmg_small
  }

  footer {
    border-top: $border-component;
    padding: $hmg_mid;
    display: flex; align-items: center;
    justify-content: space-between;
  }
</style>